<template>
    <div class="basic-image">
        <img style="width: 100%; height: 100%;" :src="getMediaSrc(ImageSrc)" />
    </div>
  </template>
  
  <script>
  import { getUmbracoMediaItemSrc } from '@/helpers/assetHelper';
  
  export default {
      name: 'BasicImage',
      props: {
          ImageSrc: String
      },
      data() {
          return {}
      },
      watch: {
      },
      computed:
      {
      },
      methods: {
          getMediaSrc(mediaItem) {
              return getUmbracoMediaItemSrc(mediaItem);
          }
      }
  }
  </script>